import { AfterViewInit, Component, ElementRef, OnDestroy, ViewChild } from '@angular/core';
import { LayoutService } from './service/app.layout.service';
import { NotificationService } from '../services/notification/notification.service';
import { AuthentificationService } from '../services/auth/authentification.service';
import { CookieService } from 'ngx-cookie-service';
import { environment } from 'src/environments/environment';
@Component({
    selector: 'app-sidebar',
    templateUrl: './app.sidebar.component.html'
})
export class AppSidebarComponent implements OnDestroy, AfterViewInit {
    @ViewChild('menuContainer') menuContainer!: ElementRef;
    @ViewChild('sidebar') sidebarRef!: ElementRef;
    logo: string = 'dark'; // par défaut
    timeout: any = null;
    access=null
    companyId: number;
    uuid: string;

    constructor(public layoutService: LayoutService,public notificationService:NotificationService,public authentificationService:AuthentificationService, public el: ElementRef, private cookieService: CookieService) {}

    ngAfterViewInit(): void {
        this.updateLogoBasedOnBackground();
    }

    updateLogoBasedOnBackground() {
        const element = this.sidebarRef.nativeElement;
        const style = window.getComputedStyle(element);
        const bgColor = style.backgroundColor;

        if (this.isDarkColor(bgColor)) {
        this.logo = 'white';
        } else {
        this.logo = 'dark';
        }
    }

    private isDarkColor(rgb: string): boolean {
        const result = rgb.match(/\d+/g);
        if (!result || result.length < 3) return false;

        const r = parseInt(result[0], 10);
        const g = parseInt(result[1], 10);
        const b = parseInt(result[2], 10);

        if (r === 100 && g === 144 && b === 254) {
          return true;
        }

        // Luminance perceptive
        const luminance = 0.299 * r + 0.587 * g + 0.114 * b;
        return luminance < 128;
    }



    onMouseEnter() {
        if (!this.layoutService.state.anchored) {
            if (this.timeout) {
                clearTimeout(this.timeout);
                this.timeout = null;
            }
            this.layoutService.state.sidebarActive = true;
            this.access = this.authentificationService.getStoredAccess();
            this.companyId = this.access.companyId;
            this.uuid = this.access.uuid
            // Merge Markdown
        }
    }

    onMouseLeave() {
        if (!this.layoutService.state.anchored) {
            if (!this.timeout) {
                this.timeout = setTimeout(() => (this.layoutService.state.sidebarActive = false), 300);
            }
        }
    }

    resetOverlay() {
        if(this.layoutService.state.overlayMenuActive) {
            this.layoutService.state.overlayMenuActive = false;
        }
    }


    anchor() {
        this.layoutService.state.anchored = !this.layoutService.state.anchored;
    }


    ngOnDestroy() {
        this.resetOverlay();
    }

  // Merge Markdown


}
